export default async ctx => {
  const { store } = ctx;

  // Check if user is connected
  if (process.server) {
    await store.dispatch('auth/checkConnectedUser', ctx);
  }
};
